<template>
  <div id="app" class="min-h-screen">
    <router-view />
    <ConfirmDialog />
  </div>
</template>

<script setup lang="ts">
import ConfirmDialog from './components/ConfirmDialog.vue'
</script>
